import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import TSelectForm from "../../common/TSelectForm";
import TInputForm from "../../common/TInputForm";

class AkismetForm extends Component {

    componentDidMount() {
        const { data } = this.props
        if (data.setting.key == '' || typeof data.setting.key == 'undefined') {
            const { onChange } = this.props
            onChange({
                setting: {
                    key: ''
                },
                validated: false
            })
        }
    }

    @autobind
    handleSelect(value) {
        const { onChange } = this.props
        onChange({
            setting: {
                key: value
            },
            validated: value != ''
        })
    }

    render() {
        const { plugin, data } = this.props
        return (
        <div className="desc_plugin2">
            <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

            <div className="info_plugin">
                <div className="item_set item_sub">
                    Akismet API 키

                    <TInputForm className="tf_set tf_set200" placeholder="API 키를 넣어주세요." onChange={this.handleSelect} value={data.setting.key}/>

                    <a href="http://akismet.com" target="_blank" className="link_other">Akismet 서비스 바로가기</a>
                </div>
            </div>
            {this.props.saveButton()}
        </div>
        )
    }
}

AkismetForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default AkismetForm
